import { css } from '@emotion/react';
import { useStore } from 'hooks/useStore';
import { useObserver } from 'mobx-react-lite';
import React from 'react';
import { NotificationStyle } from 'styles/NotificationStyle';

export const NetworkStatusBox = () => {
	const { networkStatus } = useStore();

	return useObserver(() => (
		<div
			css={css`
				position: fixed;
				top: 0;
				left: 0;
				right: 0;
				z-index: 9600;
				opacity: 0;
				visibility: hidden;
				transition: all 0.2s ease-in-out;
				text-align: center;
				transform: translate(0, -100%);
				${!networkStatus.online &&
				css`
					visibility: visible;
					opacity: 1;
					transform: translate(0, 0);
				`}
			`}
		>
			<div
				css={[
					NotificationStyle(),
					css`
						padding: 28px;
						font-size: 14px;
						line-height: 20px;
					`,
				]}
			>
				<strong
					css={css`
						font-weight: 600;
					`}
				>
					You're offline!
				</strong>{' '}
				Check your internet connection.
			</div>
		</div>
	));
};
